import { useLingui } from "@lingui/react";
import { useModals } from "@mobility-item-page/dealer/client";
import { isPrivateAdvertiser } from "@mobility-item-page/utilities";
import { Button } from "@warp-ds/elements/react/button";
import { useAdViewAd, useAdViewMeta } from "src/context/AdViewProviderContext.tsx";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import { type ContactTopic, getTopicContent } from "./contactTopics.ts";

type Props = {
  topic: ContactTopic;
};

/**
 * "Ask the seller" link used inside the EV info expandables. Dealer ads open the dealer contact
 * flow, private ads use the messaging podlet — the same one behind the main "Send message" button.
 */
export const ContactAction = ({ topic }: Props) => {
  const { i18n } = useLingui();
  const { isLoggedIn, isPreview } = useAppConfig();
  const { openContactFlow } = useModals();
  const { ownerUrn } = useAdViewMeta();
  const { adViewType } = useAdViewAd();

  const { label, trackingObjectName, message } = getTopicContent(topic, i18n, adViewType);

  if (isPreview) {
    return <Button variant="link">{label}</Button>;
  }

  if (isPrivateAdvertiser(ownerUrn)) {
    // NOTE: finn-contact-button has no prefill prop yet (v1.0.130) — its destination URL comes from
    // the podlet's own #contact-button-data blob. Hand it `message` once it does.
    // <w-button full-width> is hardcoded inside the podlet, so keep the link from filling the card
    return (
      <div className="w-fit">
        {/* @ts-expect-error TODO: fix the custom element typing */}
        <finn-contact-button buttonVariant="link" buttonText={label} trackingObjectName={trackingObjectName} />
      </div>
    );
  }

  const openContactForm = () => {
    /* trackContactUs(position); */
    if (!isLoggedIn) {
      const { origin, pathname } = window.location;
      const loginUrl = new URL(`${origin}/auth/login`);
      loginUrl.searchParams.set("redirectUrl", `${origin}${pathname}?contact=${encodeURIComponent(topic)}`);
      loginUrl.searchParams.set("cancelUrl", `${origin}${pathname}`);
      window.location.href = loginUrl.toString();
      return;
    }
    openContactFlow({ prefilledMessage: message, contactTopic: topic });
  };

  return (
    <Button variant="link" onClick={openContactForm}>
      {label}
    </Button>
  );
};
